import Modal from "modal/Modal";
import GalleryItem from "gallery/GalleryItem";
import ValueHelper from "base/ValueHelper";
import CookieHelper from "base/CookieHelper";
import Ajax from "base/Ajax";
import "blueimp-file-upload";

class AddImageModal extends Modal {
    constructor(gallery) {
        super({class: "admin-modal--navigation"});
        this.gallery = gallery;

        this.items = [];

        this.currentIndex = -1;
        this.uploadingRequests = [];

        this.setContent([
                eotwJSXFactory('div', {class: "admin-form"}, [
                    eotwJSXFactory('div', {class: "admin-modal__navigation"}, [
                        eotwJSXFactory('button', {class: "admin-modal__link admin-modal__link--active", type: "button"}, ["Add Image"]),
                        this.gallery.data.profile.allowVideos ? eotwJSXFactory('button', {class: "admin-modal__link js-add-video", type: "button"}, ["Add Video"]) : []
                    ]),
                    eotwJSXFactory('h2', null, ["Upload Photos"]),
                    eotwJSXFactory('div', {class: "admin-dropzone js-dropzone"}, [
                        eotwJSXFactory('div', {class: "admin-form__row"}, [
                            eotwJSXFactory('span', {class: "admin-dropzone__icon"}).html("<svg><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='" + window.CONFIG.adminBuildUrl + "gallery/icons.svg#add-picture'></use></svg>"),
                            eotwJSXFactory('label', {class: "admin-form__label", for: "image"}, ["Drop images here"]),
                            eotwJSXFactory('p', null, ["You can drag and drop images from your computer into this area or click the button below to select the files manually."]),
                            eotwJSXFactory('input', {type: "file", class: "js-file admin-form__input", multiple: "multiple", accept: "image/*", id: "image", name: "image"}),
                            eotwJSXFactory('span', {class: "form__inline-validation form__inline-validation--error js-inline-validation"})
                        ])
                    ]),
                    eotwJSXFactory('h4', {class: "js-files-added-header", style: "display:none"}, ["Files Added"]),
                    eotwJSXFactory('div', {class: "admin-form__row admin-form__row--progress js-progress-row"})
                ]),
                eotwJSXFactory('div', {class: "admin-modal__buttons"}, [
                    eotwJSXFactory('button', {class: "admin-btn admin-btn--confirm admin-btn--modal js-continue"}, ["Confirm"]),
                    eotwJSXFactory('button', {class: "admin-btn admin-btn--cancel admin-btn--modal js-cancel"}, ["Cancel"])
                ])
            ]
        );


        this.show();
        this.bindEvents();
        this.checkUploadingRequests();
    }

    bindEvents() {
        const me = this;
        this.on("click", ".js-add-video", () => {
            this.emit("cancel");
            this.destroy();
            this.gallery.showAddVideo();
            return false;
        });
        this.on("click", ".js-continue", () => this.proceed() && false);
        this.on("click", ".js-cancel", () => {
            this.emit("cancel");
            this.hide();
            return false
        });
        this.on("click", ".js-retry", function () {
            $(this).parents(".js-file-item").data("context").submit();

            return false;
        });
        this.on("click", ".js-remove", function () {
            let $parent = $(this).parents(".js-file-item");
            let item = $parent.data("item");
            $parent.data("context").abort();
            $parent.remove();

            if (item instanceof GalleryItem) {
                me.items = me.items.filter((other) => other !== item);

                Ajax.delete(null, item.data.href);
            }
            me.checkUploadingRequests();

            return false;
        });

        this.$element.find(".js-file").fileupload({
            dataType: "json",
            add: this.handleAddedFile.bind(this),
            submit: this.handleSubmitFile.bind(this),
            progress: this.handleProgress.bind(this),
            done: this.handleDoneUpload.bind(this),
            fail: this.handleFailedUpload.bind(this),
            dropZone: this.$element.find(".js-dropzone")
        });
    }

    destroy() {
        super.destroy();
        $(window).off("dragleave").on("dragover")
    }

    handleAddedFile(e, data) {
        this.$element.find(".js-inline-validation").text("");
        if (this.gallery.data.profile.maxItems !== null && this.items.length + this.gallery.items.length + this.uploadingRequests.length >= this.gallery.data.profile.maxItems) {
            this.$element.find(".js-inline-validation").text("This gallery is limited to " + this.gallery.data.profile.maxItems + " items");
            return;
        }
        let file = data.files[0];
        data.context = (
            eotwJSXFactory('div', {class: "admin-file-progress js-file-item"}, [
                eotwJSXFactory('div', {class: "admin-file-progress__indicator js-indicator"}),
                eotwJSXFactory('div', {class: "admin-file-progress__content"}, [
                    eotwJSXFactory('strong', null, [file.name]),
                    eotwJSXFactory('span', null, ["File size: ", ValueHelper.format_bytes(file.size)]),
                    eotwJSXFactory('div', {class: "admin-file-progress__buttons js-buttons"})
                ])
            ])
        );
        data.context.data("context", data);

        this.$element.find(".js-progress-row").append(data.context);
        data.submit();
    }

    handleSubmitFile(e, data) {
        data.ID = AddImageModal.CURRENT_ID++;
        this.uploadingRequests.push(data);
        this.checkUploadingRequests();

        data.context.removeClass("admin-file-progress--done admin-file-progress--error")
            .find(".js-buttons").html(eotwJSXFactory('span', {class: "admin-file-progress__btn"}, [eotwJSXFactory('span', {class: "admin-file-progress__icon"}).html("<svg><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='" + window.CONFIG.adminBuildUrl + "base/icons.svg#gallery-loader'></use></svg>")]));

        data.url = Ajax.getBaseUrl(Ajax.ADMIN) + "gallery/items/";
        data.formData = {
            csrf: CookieHelper.get('csrf'),
            type: "2" /* ItemType::IMAGE */
        }
    }

    handleProgress(e, data) {
        let progress = parseInt(data.loaded / data.total * 100, 10);
        data.context.find(".js-indicator").css("width", progress + "%");
    }

    handleDoneUpload(e, data) {
        this.uploadingRequests = this.uploadingRequests.filter((otherData) => data.ID !== otherData.ID);
        let response = data.result;

        if (response.success === true) {
            data.context.addClass("admin-file-progress--done").find(".js-indicator").css("width", "100%");
            let item = GalleryItem.process_item(this.gallery, response.data);
            data.context.data("item", item);
            this.items.push(item);
            data.context.find(".js-buttons").html([
                eotwJSXFactory('button', {class: "admin-file-progress__btn-text js-remove"}, ["Remove"]),
                eotwJSXFactory('span', {class: "admin-file-progress__btn"}, [eotwJSXFactory('span', {class: "admin-file-progress__icon"}).html("<svg><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='" + window.CONFIG.adminBuildUrl + "base/icons.svg#success'></use></svg>")])
            ]);
        } else {
            data.context.addClass("admin-file-progress--error").find(".js-indicator").css("width", "100%");
            data.context.find(".js-buttons").html([
                eotwJSXFactory('button', {class: "admin-file-progress__btn-text js-retry"}, ["Retry"]),
                eotwJSXFactory('span', {class: "admin-file-progress__btn"}, [eotwJSXFactory('span', {class: "admin-file-progress__icon"}).html("<svg><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='" + window.CONFIG.adminBuildUrl + "base/icons.svg#error'></use></svg>")])
            ]);
        }
        this.checkUploadingRequests();
    }

    handleFailedUpload(e, data) {
        this.uploadingRequests = this.uploadingRequests.filter((otherData) => data.ID !== otherData.ID);
        this.checkUploadingRequests();

        let text = data.xhr().responseText;
        console.error("Connection error", e, data, text);

        data.context.addClass("admin-file-progress--error").find(".js-indicator").css("width", "100%");
        data.context.find(".js-buttons").html([eotwJSXFactory('button', {class: "admin-file-progress__btn-text js-retry"}, ["Retry"]), eotwJSXFactory('button', {class: "admin-file-progress__btn js-remove"}, [eotwJSXFactory('span', {class: "admin-file-progress__icon"}).html("<svg><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='" + window.CONFIG.adminBuildUrl + "base/icons.svg#error'></use></svg>")])]);
    }

    checkUploadingRequests() {
        if (this.items.length === 0 || this.uploadingRequests.length > 0) {
            this.$element.find(".js-continue").attr("disabled", true).addClass("admin-btn--disabled")
        } else {
            this.$element.find(".js-continue").attr("disabled", false).removeClass("admin-btn--disabled")
        }
        if (this.items.length > 0 || this.uploadingRequests.length > 0) {
            this.$element.find(".js-files-added-header").show();
        } else {
            this.$element.find(".js-files-added-header").hide();
        }
    }

    proceed() {
        if (++this.currentIndex >= this.items.length) {
            this.emit('images', this.items);
            this.hide();
            return;
        }

        let item = this.items[this.currentIndex];
        let modal = item.getModal({okayText: this.currentIndex + 1 >= this.items.length ? null : "Next", title: "Image " + (this.currentIndex + 1) + " of " + this.items.length});

        modal.on("cancel", () => this.emit("cancel") && this.hide());
        modal.on("okay", () => this.proceed());
        modal.show();
    }
}

AddImageModal.CURRENT_ID = 0;

export default AddImageModal;
